import React from 'react';

const videoData = [
  {
    id: 1,
    title: 'Get Oriented',
    description: 'Overwhelmed by the hype around Gen AI and its disruptive impact? The first step is to recognize the immense future potential, but also learn the state of the art.\n\nBusiness leaders around the world are investing in projects that deliver immediate returns based on current technology. \n\n <b>Listen in</b>.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2FStepper%20One%20Final%20Cut.mp4?alt=media&token=9af62958-e3dc-4d5d-81d8-20c81fc4047c',
    poster: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2Fvideo1thumb.png?alt=media&token=94460106-eba1-4dc3-a121-1ae55dd539fc',
  },
  {
    id: 2,
    title: 'Start Planning',
    description: 'What uses cases for Gen AI exist within your organization/department? Identify the savings to be unlocked or the opportunities to be realized. \n\n Then calculate the return on investment to make a decision. \n\n <b>Play the video to learn how</b>.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2FStepper%20Two%20Final%20Cut.mp4?alt=media&token=2e8bfaee-b3f9-48e5-a327-729c5be9553d',
    poster: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2Fvideo2thumb.png?alt=media&token=4948f6a4-7c4c-4fde-8601-be33cfb801d1',
  },
  {
    id: 3,
    title: 'Execute and Enhance',
    description: 'Once you\'ve made a decision, you need to move quickly to minimize opportunity cost. Finding the right partner to not just deliver a solution but help with AI transformation methodology is crucial. \n\n Informulate is your long term partner that delivers with quality, extensibility and security.  \n\n <b>Click to learn more</b>.',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2FStepper%20Three%20Final%20Cut.mp4?alt=media&token=d81ef9f5-e67b-4a16-b901-03e4ccde72f4',
    poster: 'https://firebasestorage.googleapis.com/v0/b/aiar-25d06.appspot.com/o/informulate.ai%2Fvideo3thumb.png?alt=media&token=3bb8e27d-8c62-468a-a312-17100a3e0ce5',
  }
];

const VideoCard = ({ data, isPlaying, onPlay }) => {
  const { id, title, description, videoUrl, poster } = data;
  const videoRef = React.useRef(null);

  // Effect to play/pause video when isPlaying state changes
  React.useEffect(() => {
    const videoElement = document.getElementById(`video-mobile-${id}`);
    if (videoElement) {
      if (isPlaying === id) {
        // Play the video when this card's ID matches the playing ID
        videoElement.play().catch(error => {
          console.error("Error playing video:", error);
        });
      } else {
        // Pause the video when another video is playing
        videoElement.pause();
      }
    }
  }, [isPlaying, id]);

  return (
    <div className="mb-16">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-16 h-16 rounded-full bg-purple/10 flex items-center justify-center">
          <span className="text-purple font-semibold text-2xl">{id}</span>
        </div>
        <h3 className="text-2xl font-bold">{title}</h3>
      </div>
      
      <div className="text-gray-600 mb-6">
        {description.split('\n\n').map((paragraph, i) => {
          const parts = paragraph.split(/(<b>.*?<\/b>)/g);
          return (
            <p key={i} className="mb-2">
              {parts.map((part, j) => {
                if (part.startsWith('<b>') && part.endsWith('</b>')) {
                  const boldText = part.replace(/<\/?b>/g, '');
                  return <span key={j} className="font-bold">{boldText}</span>;
                }
                return <span key={j}>{part}</span>;
              })}
            </p>
          );
        })}
      </div>

      <div className="relative aspect-video rounded-xl overflow-hidden">
        <video
          id={`video-mobile-${id}`}
          ref={videoRef}
          className="w-full h-full object-cover"
          controls={isPlaying === id}
          poster={poster}
          playsInline
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
        {isPlaying !== id && (
          <>
            <div className="absolute inset-0 bg-black/70" />
            <div
              className="absolute inset-0 flex items-center justify-center cursor-pointer"
              onClick={() => onPlay(id)}
            >
              <div className="video-one__play">
                <span className="fa-solid fa-play fa-fw">
                  <i className="ripple"></i>
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const TransformationStepsMobile = () => {
  const [playingVideo, setPlayingVideo] = React.useState(null);

  return (
    <section className="py-16 bg-white block lg:hidden">
      <div className="mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block py-1 px-4 bg-purple/5 border-purple/10 border rounded-full font-medium text-purple mb-4">
            <span>AI Solutions Showcase</span>
          </div>
          <h2 className="text-3xl font-semibold">
            Discover How AI Can Transform Your Business
          </h2>
        </div>

        <div className="space-y-8">
          {videoData.map((data) => (
            <VideoCard
              key={data.id}
              data={data}
              isPlaying={playingVideo}
              onPlay={setPlayingVideo}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TransformationStepsMobile; 